import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SlideSwitch } from '@els/els-react--slide-switch';
import SelectAllItemsControls from '@Containers/ResultToolbar/SelectedItemsControls/SelectAllItemsControls';

import './StepSelectionHeader.scss';

/* eslint-disable react-hooks/exhaustive-deps */
function StepSelectionHeader({ selectedRowsCount, maxRowsCount, isPredicted, selectAllHandler, isViewOnlySelected, setViewOnlySelected }) {
  const [isAllRowsSelected, setAllRowsSelected] = useState(false);

  const checkAllSteps = (selected) => {
    setAllRowsSelected(selected);
    selectAllHandler(selected);
  };

  useEffect(() => {
    if (isAllRowsSelected && selectedRowsCount < maxRowsCount) {
      setAllRowsSelected(false);
    } else if (!isAllRowsSelected && selectedRowsCount > 0 && selectedRowsCount === maxRowsCount) {
      setAllRowsSelected(true);
    }
  }, [selectedRowsCount]);

  return (
    <div className={`project-route-step-selection ${isPredicted ? 'project-route-step-selection--predicted' : ''}`}>
      <SelectAllItemsControls
        checkAllItems={checkAllSteps}
        allItemsSelected={isAllRowsSelected}
        currentSelectedItems={selectedRowsCount}
        someItemsSelected={selectedRowsCount > 0 && selectedRowsCount < maxRowsCount}
      />
      <div className="project-route-step-selection--view-selected-wrapper">
        <SlideSwitch
          label="View selected"
          disabled={selectedRowsCount === 0}
          checked={isViewOnlySelected}
          onChange={(event) => setViewOnlySelected(event, event.currentTarget.checked)}
          e2eName="viewSelected"
        />
      </div>
    </div>
  );
}

StepSelectionHeader.propTypes = {
  selectedRowsCount: PropTypes.number,
  maxRowsCount: PropTypes.number,
  selectAllHandler: PropTypes.func,
  setViewOnlySelected: PropTypes.func,
  isViewOnlySelected: PropTypes.bool,
  isPredicted: PropTypes.bool,
};

export default StepSelectionHeader;
